import { PickerButtonGroup, PickerSection } from './_PickerSection';
import type { ServingTier } from './types';

interface ServingPickerProps {
  label: string;
  tiers: Array<ServingTier>;
  selectedKey: string;
  onSelect: (key: string) => void;
  theme: 'dark' | 'light';
}

export function ServingPicker({ label, tiers, selectedKey, onSelect, theme }: ServingPickerProps) {
  return (
    <PickerSection label={label} theme={theme}>
      <PickerButtonGroup
        theme={theme}
        options={tiers.map((tier) => ({
          key: tier.key,
          label: tier.label,
          isSelected: tier.key === selectedKey,
          onSelect: () => onSelect(tier.key),
        }))}
      />
    </PickerSection>
  );
}
